// Vendor libraries
import { ComponentFactoryResolver, Type, DOCUMENT } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ConfigModule } from 'NewAngular/config/config.module';
import { StoreModule } from '@ngrx/store';
import { getLogger } from 'NewAngular/state/logger';
import { CommonModule } from '@angular/common';
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
// Modules
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const entryComponents = [];
export class StocksFundamentalsAppModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [];
    }
}
StocksFundamentalsAppModule.ɵfac = function StocksFundamentalsAppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StocksFundamentalsAppModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
StocksFundamentalsAppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: StocksFundamentalsAppModule });
StocksFundamentalsAppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        CommonModule,
        ConfigModule,
        FeatureNeededModule,
        IconModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
